import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedService } from './shared.service';
import { SiteConfig } from './interfaces/SiteConfig';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public prefilledWbkz: String;
  public prefilledSalutation: String;
  public prefilledCoupon: String;
  public showCartPage: Boolean = false;
  public siteConfig: SiteConfig;

  constructor(private sharedService: SharedService, private router: Router) {
    this.sharedService.triggerInitEvent();
  }

  ngOnInit() {
    /*
     * Get configuration from
     * global, external config file via
     * window.
     * Configuration object is added to window
     * as property.
     */
    this.siteConfig = this.sharedService.getSiteConfig();
    this.showCartPage = this.siteConfig.showCartPage;

    this.getPrefilledCoupon();
    this.getPrefilledSalutation();

    /*
     * Scroll to top on route change
     */
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }

      window.scrollTo(0, 0);
    });
  }

  /**
   * Since there are several ways to prefill a coupon, check all the possibilities.
   * The several ways are via URL which sets a cookie named 'coupon' / 'coupon-set' (Typo3),
   * or via nkl-config.
   *
   * Check if coupon is set via cookie named 'coupon'. If yes, use it.
   * => If not, check if coupon is set via cookie named 'coupon-set'. If yes, use it.
   * => If not check if coupon is checked via config. If yes, use it.
   * => If not coupon is NOT prefilled.
   */
  getPrefilledCoupon(): void {
    const submittedCoupon = this.sharedService.getSessionStorage('couponData');
    this.prefilledCoupon = this.sharedService.getCookie('coupon')
      ? this.sharedService.getCookie('coupon')
      : this.sharedService.getCookie('coupon-set')
      ? this.sharedService.getCookie('coupon-set')
      : this.siteConfig.coupon
      ? this.siteConfig.coupon
      : '';

    if (this.prefilledCoupon && !submittedCoupon.submitted) {
      this.sharedService.setSessionStorage('couponData', {
        code: this.prefilledCoupon,
        submitted: false
      });
    }
  }

  /**
   * Check for set wbkz and gender:
   *
   * - checks if wbkz or gender (salutation) is set via URL param (e.g. url.com?wbkz=XYZ123)
   *   or saved in cookie
   * - if not set default values from site config
   * - save prefilled information to localStorage.
   */
  getPrefilledSalutation(): void {
    this.prefilledSalutation =
      this.sharedService.getCookie('gender') === 'f' ? 'Frau' : 'Herr';

    this.sharedService.setLocalStorage('prefilled', {
      salutation: this.prefilledSalutation
    });
  }
}
